import React from 'react';
import { Box } from '@chakra-ui/react';
import PropType from 'prop-types';

const JobStatusBadge = ({ status, badgeStyle, ...rest }) => (
  <Box
    alignItems="center"
    borderRadius="sm"
    display="flex"
    height="32px"
    justifyContent="center"
    layerStyle={badgeStyle}
    textStyle="bodySm500"
    width="70px"
    {...rest}
  >
    {status}
  </Box>
);

JobStatusBadge.propTypes = {
  status: PropType.string,
  badgeStyle: PropType.string
};

export default JobStatusBadge;
